import _ from 'lodash';
import { Moment } from 'moment';
import React from 'react';
import { GoodTable } from '@good/ui/templates';

import { DayColumn } from './DayColumn';
import { OpenSlotsDetailsColumn } from './open-slots-details-column';
import { IRosterShift } from '../../types';
import { OpenSlotCardList } from './open-slot-card-list';
import { rosterConfig } from '../../roster-config';

interface OpenSlotsRowProps {
  openShifts?: IRosterShift[];
  days: Moment[];
}

export function OpenSlotsRow({ openShifts, days }: OpenSlotsRowProps) {
  const numberOfSlots = _.size(openShifts);

  return (
    <GoodTable.Tr>
      <GoodTable.Td sticky bg={rosterConfig.grayColor}>
        <OpenSlotsDetailsColumn numberOfSlots={numberOfSlots} />
      </GoodTable.Td>

      {_.map(days, (day, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <GoodTable.Td key={idx}>
          <DayColumn content={<OpenSlotCardList day={day} shifts={openShifts} />} />
        </GoodTable.Td>
      ))}
    </GoodTable.Tr>
  );
}
